import { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { writetoLS } from '@orientaction/utils';

const ActivateMatch = () => {
  useEffect(() => {
    // Enregistrer activateMatch dans localStorage
    writetoLS('activateMatch', 'true');
  }, []);

  // Rediriger vers l'accueil
  return <Redirect to="/main" />;
};

export default ActivateMatch;
